exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".authors{align-items:center;display:flex}.authors__avatar{margin-left:-22px;position:relative}.authors__avatar:first-child{margin-left:0}.authors__names{font-size:16px;font-size:1rem;margin-left:13px}.authors__tooltip{padding:5px 8px}\n", ""]);

// exports
exports.locals = {
	"authors": "authors",
	"authors__avatar": "authors__avatar",
	"authors__names": "authors__names",
	"authors__tooltip": "authors__tooltip"
};